import { createSelector } from 'reselect'

const NUM_STEPS = 7;

const getPattern = (pattern, currentStep) => pattern;
const getStepBuckets = (pattern, currentStep) => pattern.stepBuckets;
const getCurrentStep= (pattern, currentStep) => currentStep;
export const getSteps = 
    (pattern, currentStep) => {
        let length = pattern.length();
        let steps = [];
        for (let i=-3; i <= 3; i++) {
            let stepNumber = (currentStep + i)*2 % length;
            if (currentStep + i < 0) {
                stepNumber = length + i*2;
            } 
            let stepBucket = pattern.stepBuckets[stepNumber];
            let onStep = stepBucket.getAnyOnStep() || stepBucket.steps[0];
            steps.push({stepData: onStep, stepNumber: stepNumber / 2});
        }
        return steps;
    };

